<script>
    import { buttonStates } from '@repo/config/Global';

    /**
     * @typedef {Object} Props
     * @property {boolean} [disabled]
     * @property {any} [state]
     * @property {any} title
     * @property {any} imageUrl
     * @property {boolean} [showIcon]
     * @property {boolean} [showTitle]
     * @property {number} [tabindex]
     */
    let {
        disabled = false,
        state = buttonStates.NEUTRAL,
        title,
        imageUrl,
        showIcon = false,
        showTitle = true,
        onclick = () => {},
    } = $props();
    
    let tabindex = $derived.by(() => {
        return disabled ? null : 0;
    });
</script>

<button type="button" {tabindex} onclick={onclick} class="button submit interactive {state}" disabled={disabled} title={title}>
    <img src={imageUrl} alt="">
    {#if showTitle}
        <span>{title}</span>
        <div class="spacer"></div>
    {/if}
    {#if showIcon}
        <i class="material-icons" aria-hidden="true">chevron_right</i>
    {/if}
</button>


<style>
    
    .button{
        display:flex;
        align-items: center;
        justify-content: space-between;
        padding:0.5rem;
        border-radius:0.5rem;
        font-weight:600;
        font-size:0.8rem;
        text-transform: uppercase;
        align-self:center;
        cursor: pointer;
    }
    
    .button span{
        font-weight:inherit;
        font-size: inherit;
        margin-right:0.75rem;
    }

    .button:hover{
        opacity:0.7;
        box-shadow:0 0.25rem 0.5rem rgba(0,0,0,0,25);
    }

    .button_state_error{
        background-color:crimson;
        color:white;
    }

    .button_state_warn{
        background-color:rgb(255, 192, 74);
        color:#333;
    }

    .button_state_waiting{
        background-color:rgb(74, 198, 255);
        color:#333;
    }

    .button_state_neutral{
        background-color:white;
        color:#333;
    }
    .button_state_success{
        background-color:rgb(74, 255, 83);
        color:#333;
    }

    .button img{
        height:2rem;
        
    }


</style>